import { PayPalButtonOnError } from "@paypal/paypal-js"
import { setExpressCheckoutActive, setExpressCheckoutErrorMessage } from "src/checkout/state/checkoutExpressStore"
import { paypalLogPrefix } from "src/integrations/paypal/constants"
import { genericErrorMessage } from "src/utilities/errorMessages"
import { recordError } from "src/utilities/errorReporting"

export const payPalButtonOnError: PayPalButtonOnError = async (error) => {
  recordError(paypalLogPrefix + " onError called", error)
  setExpressCheckoutErrorMessage(genericErrorMessage)
  setExpressCheckoutActive(false)
}
